var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[(_vm.showPageNavigation)?_c('side-bar'):_vm._e(),_c('main',{staticClass:"main-window",class:{
      'authenticated': _vm.showPageNavigation
    }},[_c('section',{staticClass:"main-content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }